/**
 * Escapes null bytes in a string for PostgreSQL JSONB storage.
 * PostgreSQL does not support null bytes in JSONB, so we escape them
 * as Unicode escape sequences.
 */
export function escapeNullBytes(value: string): string {
  // oxlint-disable-next-line no-control-regex -- Intentionally matching null bytes for PostgreSQL JSONB escaping
  return value.replaceAll('\0', '\\u0000')
}

/**
 * Unescapes null bytes from a string retrieved from PostgreSQL.
 */
export function unescapeNullBytes(value: string): string {
  return value.replaceAll('\\u0000', '\0')
}

/**
 * Recursively escapes null bytes in all string values within an object.
 */
export function escapeNullBytesDeep(value: unknown): unknown {
  if (typeof value === 'string') {
    return escapeNullBytes(value)
  }
  if (Array.isArray(value)) {
    return value.map((item) => escapeNullBytesDeep(item))
  }
  if (value instanceof Date) {
    return value.toISOString()
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(value)) {
      result[k] = escapeNullBytesDeep(v)
    }
    return result
  }
  return value
}

/**
 * Recursively unescapes null bytes in all string values within an object.
 */
export function unescapeNullBytesDeep(value: unknown): unknown {
  if (typeof value === 'string') {
    return unescapeNullBytes(value)
  }
  if (Array.isArray(value)) {
    return value.map((item) => unescapeNullBytesDeep(item))
  }
  if (value instanceof Date) {
    return value
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(value)) {
      result[k] = unescapeNullBytesDeep(v)
    }
    return result
  }
  return value
}
